<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayout="row" fxLayoutAlign="start">
		<!-- <app-image (complete)="onUpdateAvatar($event)" (onProgress)="onProgressed($event)" [fileName]="'avatar.jpg'" [height]="64" [username]="content.username" [view]="'rename'" [width]="64" style="margin:8px"></app-image> -->
		<div class="card-title">
			<h2 mat-dialog-title style="font-size: 24px;color:#ffffff;font-weight: 600;"><span data-idtest="welcome-dialog-t-9Rd">{{dialog_name}}</span></h2>
		</div>
	</div>

	<mat-dialog-content>
		<mat-card>
			<mat-card-header>
				<mat-card-title>{{content.username}}</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<div fxLayout="row wrap" fxLayoutAlign="space-around">
						<mat-form-field class="input-text" fxFlex="40">
							<mat-label><span data-idtest="welcome-dialog-t-6Te" translate>メールアドレス</span></mat-label>
							<input data-idtest="welcome-dialog-i-8Tw" #username="ngModel" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス' | translate}}" required type="email">
							<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスで</span></mat-error>
							<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
							<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
						</mat-form-field>
						<mat-form-field class="input-text" fxFlex="40">
							<mat-label><span data-idtest="welcome-dialog-t-9Tz" translate>名前</span></mat-label>
							<input data-idtest="welcome-dialog-i-4Mh" #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="60" minlength="2" name="nickname" placeholder="{{'お名前' | translate}}" required type="text">
							<mat-hint><span data-idtest="welcome-dialog-t-3Bt" translate>3文字以上500文字まで</span></mat-hint>
							<mat-error *ngIf="nickname.errors?.['required'];"><span translate>入力してください</span></mat-error>
							<mat-error *ngIf="nickname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
							<mat-error *ngIf="nickname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
						</mat-form-field>
						<button mat-mini-fab matTooltip="{{'メールアドレス・名前を自動で設定' | translate}}" color="primary" [disabled]="authIs('manager')" (click)="newUsername()">
							<mat-icon>autorenew</mat-icon>
						</button>
					</div>

					<mat-form-field class="form-field">
						<mat-label><span data-idtest="welcome-dialog-t-9Ci" translate>パスワード</span></mat-label>
						<input data-idtest="welcome-dialog-i-8Ke" #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'パスワード'| translate}}" required type="password">
						<mat-hint><span data-idtest="welcome-dialog-t-0Bl" translate>6文字以上1000文字まで</span></mat-hint>
						<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>

					<mat-form-field class="form-field">
						<mat-label><span data-idtest="welcome-dialog-t-8Oc" translate>パスワードをもう一度</span></mat-label>
						<input data-idtest="welcome-dialog-i-4Oy" #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'パスワード(確認)'| translate}}" required type="password">
						<mat-hint><span data-idtest="welcome-dialog-t-3Hn" translate>6文字以上1000文字まで</span></mat-hint>
						<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
						<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
					</mat-form-field>
<!--
					<div style="margin:20px 0;">
						<div data-idtest="welcome-dialog-t-2Nu" translate>会員種別を選択してください</div>
						<mat-button-toggle-group data-idtest="welcome-dialog-b-3Tx" style="margin: 20px 0;width: fit-content;" (change)="onTypeChange($event)" *ngIf="authIs('manager')">
							<mat-button-toggle data-idtest="welcome-dialog-b-2Fi" [ngStyle]="selectedToggle('studio')"  value="studio" aria-label="studio">
								<span data-idtest="welcome-dialog-t-6Ry" [ngStyle]="selected('studio')" translate>スタジオ</span>
							</mat-button-toggle>
							<mat-button-toggle data-idtest="welcome-dialog-b-1Ud" [ngStyle]="selectedToggle('user')" value="user" aria-label="user">
								<span data-idtest="welcome-dialog-t-1Zg" [ngStyle]="selected('user')" translate>生徒</span>
							</mat-button-toggle>
						</mat-button-toggle-group>
					</div>
					-->
		<!--			<div data-idtest="welcome-dialog-t-1Rg" translate>生徒の場合は紐づけるトレーナーアカウントを選択してください。システム上必ず設定が必要な項目となります。</div> -->
					<mat-form-field *ngIf="authIs('') && type === 'user'" style="width: 100%;">
						<mat-label><span translate>スタジオ</span></mat-label>
						<mat-select #studio_select="ngModel" [(ngModel)]="studio" (selectionChange)="onChangeStudio($event)" name="studio_select" [required]="!authIs('manager')">
							<mat-option *ngFor="let studio of studios" [value]="studio">
								{{studio.content.nickname}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="studio_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
					</mat-form-field>
					<mat-form-field class="input-text" *ngIf="!authIs('manager') && !authIs('studio')">
						<mat-label><span data-idtest="welcome-dialog-t-9Lp" translate>詳細</span></mat-label>
						<textarea data-idtest="welcome-dialog-i-6Nm" #description="ngModel" [(ngModel)]="content.description" matInput maxlength="255" name="description" placeholder="Description" type="text"></textarea>
						<mat-hint><span data-idtest="welcome-dialog-t-0Lo" translate>3文字以上500文字まで</span></mat-hint>
						<mat-error *ngIf="description.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
					</mat-form-field>
					<div
						fxLayout="row wrap"
						fxLayoutAlign="space-between"
						*ngIf="authIs('manager') || authIs('studio')"
					>
						<mat-form-field
							class="input-text"
							[fxFlex]="
								authIs('manager')
									? 60
									: authIs('studio') &&
									  user.enable_reservation_link
									? 60
									: 100
							"
						>
							<mat-label
								><span
									data-idtest="welcome-dialog-t-9Lp"
									translate
									>詳細</span
								></mat-label
							>
							<textarea
								data-idtest="welcome-dialog-i-6Nm"
								#description="ngModel"
								[(ngModel)]="content.description"
								matInput
								maxlength="255"
								name="description"
								placeholder="Description"
								type="text"
							></textarea>
							<mat-hint
								><span
									data-idtest="welcome-dialog-t-0Lo"
									translate
									>3文字以上500文字まで</span
								></mat-hint
							>
							<mat-error *ngIf="description.errors?.['maxlength']"
								><span translate>長すぎます</span></mat-error
							>
						</mat-form-field>
						<div
							*ngIf="authIs('manager')"
							class="input-text"
							fxFlex="30"
							style="
								display: flex;
								flex-direction: column;
								gap: 10px;
							"
						>
							<mat-label style="text-align: left"
								><span
									data-idtest="welcome-dialog-t-6Teasbc"
									translate
									>予約システム連携店舗</span
								></mat-label
							>
							<section style="display: flex">
								<mat-button-toggle-group
									class="store-link-toggle"
									data-idtest="shotdata-s-9Vl2ss"
									name="favoriteColor"
									[(ngModel)]="
										!!content.enable_reservation_link
									"
								>
									<mat-button-toggle [value]="false"
										>OFF</mat-button-toggle
									>
									<mat-button-toggle [value]="true"
										>ON</mat-button-toggle
									>
								</mat-button-toggle-group>
							</section>
						</div>

						<mat-form-field
							fxFlex="30"
							class="input-text"
							*ngIf="
								authIs('studio') && user.enable_reservation_link
							"
						>
							<mat-label
								><span
									data-idtest="welcome-dialog-t-9Tz"
									translate
									>予約システム連携ID</span
								></mat-label
							>

							<textarea
								data-idtest="welcome-dialog-i-4Mhdef"
								#reserv_id="ngModel"
								[(ngModel)]="content.reserv_id"
								matInput
								maxlength="40"
								name="reserv_id"
								placeholder="{{
									'予約システム連携ID' | translate
								}}"
								type="text"
							></textarea>

							<mat-hint
								><span
									data-idtest="welcome-dialog-t-3Bt"
									translate
									>0文字以上40文字まで</span
								></mat-hint
							>
							<mat-error *ngIf="reserv_id.errors?.['maxlength']"
								><span translate>長すぎます</span></mat-error
							>
						</mat-form-field>
					</div>

					<div fxLayout="row wrap" *ngIf="type === 'user'" fxLayoutAlign="space-around">

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-5Zk" translate>身長</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-7Wc">cm</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-9Mi" translate>ゴルフ暦</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-7Jw" translate>年</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-6Tj" translate>平均スコア</span></mat-label>
							<input [(ngModel)]="content.score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-3Gs" translate>ドライバーの距離</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-3Zb">Yard</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-3Ez" translate>7番アイアンの距離</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-0Ec">Yard</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-3Qw" translate>年間ラウンド回数</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.rounds" fxFlex="80" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-5Kb" fxFlex translate>回/年</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-4Oa" translate>月間練習回数</span></mat-label>
							<div fxLayout="row">
								<input [(ngModel)]="content.practice" fxFlex="80" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
								<div data-idtest="welcome-dialog-t-9Qy" fxFlex translate>回/月</div>
							</div>
						</mat-form-field>

						<mat-form-field class="input-text">
							<mat-label><span data-idtest="welcome-dialog-t-3Gp" translate>オフィシャルハンディ</span></mat-label>
							<input [(ngModel)]="content.handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
						</mat-form-field>
					</div>

				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around">
		<button data-idtest="welcome-dialog-b-4Sr" (click)="cancel()" [disabled]="isProgress" color="warn" mat-dialog-close="" mat-raised-button id="mat-cancel-button"><span data-idtest="welcome-dialog-t-4Pn" translate>キャンセル</span></button>
		<button data-idtest="welcome-dialog-b-1Vt" (click)="onAccept()" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button id="mat-ok-button"><span data-idtest="welcome-dialog-t-9Lr" translate>OK</span></button>
	</mat-dialog-actions>
</div>
